import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../base-dialog';
import { IconUser } from '../../../app/icons/user';
import { IconButton } from '../../../app/icon/button/icon-button';
import { BecomePartnerForm } from '../../forms/become-partner-form';
import { useRootStore } from '../../../../providers/root-store-provider';
import { BecomePartnerMobxDto } from '../../../../models/mobx/dtos/partner/become-partner-mobx-dto';
import { Alert } from '../../../app/alert/alert';
import { IconCheck } from '../../../app/icons/check';

export type BecomePartnerType = {
    email?: string;
};

export const BecomePartnerDialog: React.FC<BecomePartnerType> = observer(({ email }: BecomePartnerType) => {
    const { t } = useTranslation();
    const rootStore = useRootStore();
    const { partnerDialogStore } = rootStore;
    const [isSent, setIsSent] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const onBecomePartner = async (values: BecomePartnerMobxDto) => {
        try {
            setIsLoading(true);
            const payload = {
                fullName: values.name,
                email: values.email,
                phone: values.phone,
            };

            const response = await fetch('https://n8n.atreo.cz/webhook/monery-b2b-partners', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                setIsSent(true);
                setIsLoading(false);
            }

            if (!response.ok) {
                throw new Error(`Server error: ${response.status}`);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.error('Chyba při odesílání partnera:', e);
        }
    };

    return (
        <>
            <BaseDialog
                opened={partnerDialogStore.activeModal === 'becomePartner'}
                close={() => partnerDialogStore.closeDialog()}
                icon={<IconButton icon={isSent ? <IconCheck /> : <IconUser />} />}
                title={isSent ? t('dialogs.becomePartner.titleIsSent') : t('dialogs.becomePartner.title')}
                loading={isLoading}
                content={
                    isSent ? (
                        <Alert type={'success'}>{t('dialogs.becomePartner.success')}</Alert>
                    ) : (
                        <BecomePartnerForm onSubmit={onBecomePartner} email={email} />
                    )
                }
            />
        </>
    );
});
